var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-base-modal p-4 sm:p-8"},[(!_vm.hideHeader)?_c('header',{staticClass:"pb-10 text-center"},[_vm._t("header")],2):_vm._e(),_c('section',[_vm._t("default")],2),_c('footer',{class:{ 'pt-4 sm:pt-8': !!_vm.$slots.footer }},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }